(function ($) {
  'use strict';

  /* ── Regex patterns (mirror PHP) ──────────────────────────────────────── */
  const PATTERNS = {
    name: /^[a-zA-Z\s\-'\.]{2,}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^\+?[\d\s\-]{7,17}$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
  };

  /* ── i18n ──────────────────────────────────────────────────────────────
   * Looks up the live translated string first (kept current across an
   * in-page language switch by language-switcher.js's swapUiStrings()),
   * then the value localized for the language the page was loaded in
   * (wp_localize_script'd as qcsRegisterI18n — see functions.php), then
   * falls back to the English default passed in.
   */
  function t(key, fallback) {
    const live = window.dvTranslation && window.dvTranslation.uiStrings;
    if (live && live[key] !== undefined) {
      return live[key];
    }
    if (window.qcsRegisterI18n && window.qcsRegisterI18n[key] !== undefined) {
      return window.qcsRegisterI18n[key];
    }
    return fallback;
  }

  /* ── Field rules ───────────────────────────────────────────────────────── */
  const RULES = {
    user_type: {
      validate: (v) => v !== '',
      message: () => t('register_err_account_type', 'Please select an account type.'),
    },
    first_name: {
      validate: (v) => PATTERNS.name.test(v),
      message: () => t('register_err_first_name_length', 'First name must be at least 2 characters (letters only).'),
    },
    last_name: {
      validate: (v) => PATTERNS.name.test(v),
      message: () => t('register_err_last_name_length', 'Last name must be at least 2 characters (letters only).'),
    },
    phone: {
      validate: (v) => PATTERNS.phone.test(v),
      message: () => t('register_err_phone_format', 'Contact number must be 7–15 digits (optional + prefix).'),
    },
    email: {
      validate: (v) => PATTERNS.email.test(v),
      message: () => t('register_err_email', 'Please enter a valid email address.'),
    },
    password: {
      validate: (v) => PATTERNS.password.test(v),
      message: () =>
        t(
          'register_err_password_format',
          'Password must be at least 8 characters long, contain one uppercase, one number, and one special character.'
        ),
    },
    confirm_password: {
      validate: (v) => v !== '' && v === $('#password').val(),
      message: () => t('register_err_password_mismatch', 'Passwords do not match.'),
    },
    privacy: {
      validate: () => $('#privacy').is(':checked'),
      message: () => t('register_err_privacy', 'You must accept the privacy policy.'),
    },
  };

  /* ── DOM refs ──────────────────────────────────────────────────────────── */
  const $form = $('#custom-register-form');
  const $submitBtn = $('#qcs-submit-btn');
  const $btnText = $submitBtn.find('.qcs-btn-text');
  const $spinner = $submitBtn.find('.qcs-btn-spinner');
  const $banner = $('#qcs-form-errors');

  /* ── Helpers ───────────────────────────────────────────────────────────── */
  function getVal(name) {
    return ($form.find(`[name="${name}"]`).val() || '').trim();
  }

  function collectErrors() {
    const errors = [];
    Object.entries(RULES).forEach(([name, rule]) => {
      let val = getVal(name);
      if (name === 'privacy') {
        val = '';
      }
      if (!rule.validate(val)) {
        errors.push(rule.message());
      }
    });
    return errors;
  }

  function showBanner(messages) {
    const html = messages.map((m) => `<p class="error">${m}</p>`).join('');
    $banner.html(html).show();
    $('html, body').animate({ scrollTop: $banner.offset().top - 150 }, 300);
  }

  function clearBanner() {
    $banner.hide().html('');
  }

  /* ── Password visibility toggle ────────────────────────────────────────── */
  $form.on('click', '.qcs-pw-toggle', function () {
    const target = $(this).data('target');
    const $input = $(`#${target}`);
    const isShown = $(this).data('toggle') === 1;
    if (isShown) {
      $(this).data('toggle', 0);
      $input.attr('type', 'password');
      $(this)
        .find('.pmpro_form_field-password-toggle-state')
        .text(t('register_show_password', 'Show Password'));
    } else {
      $(this).data('toggle', 1);
      $input.attr('type', 'text');
      $(this)
        .find('.pmpro_form_field-password-toggle-state')
        .text(t('register_hide_password', 'Hide Password'));
    }
  });

  /* ── Submit ─────────────────────────────────────────────────────────────── */
  $form.on('submit', function (e) {
    e.preventDefault();
    clearBanner();

    /* 1. Client-side validation */
    const errors = collectErrors();
    if (errors.length) {
      showBanner(errors);
      return;
    }

    /* 2. All good — fire AJAX */
    $submitBtn.prop('disabled', true);
    $btnText.hide();
    $spinner.show();

    const data =
      $form.serialize() +
      '&action=qcs_register' +
      '&secure_register_nonce=' +
      encodeURIComponent(window.ajax_callback_data.ajax_nonce);

    $.ajax({
      url: window.ajax_callback_data.ajax_url,
      method: 'POST',
      data: data,

      success: function (res) {
        if (res.success) {
          window.location.href = res.data.redirect;
          return;
        }

        /* Server returned errors — flatten all messages into the banner */
        const errs = res.data || {};
        const serverMessages = [];

        Object.values(errs).forEach((msgs) => {
          if (Array.isArray(msgs)) {
            msgs.forEach((m) => serverMessages.push(m));
          }
        });

        let messagesToShow = [t('register_err_generic', 'An unexpected error occurred. Please try again.')];
        if (serverMessages.length > 0) {
          messagesToShow = serverMessages;
        }
        showBanner(messagesToShow);
        $submitBtn.prop('disabled', false);
        $btnText.show();
        $spinner.hide();
      },

      error: function () {
        showBanner([t('register_err_network', 'A network error occurred. Please try again.')]);
        $submitBtn.prop('disabled', false);
        $btnText.show();
        $spinner.hide();
      },
    });
  });
})(jQuery);
